import { Injectable } from '@angular/core';
import { interval, Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AutoRefreshService {
  constructor() {}

  setupAutoRefresh(
    refreshRate: number | null,
    destroy$: Subject<void>,
    callback: () => void,
  ): Subscription | null {
    let isRefreshing = false; // Flag to track if a callback is already running

    if (refreshRate && refreshRate > 0) {
      const refreshSubscription = interval(refreshRate)
        .pipe(takeUntil(destroy$))
        .subscribe(() => {
          if (!isRefreshing) {
            // Only run if no callback is currently running
            isRefreshing = true;
            try {
              callback(); // Run the callback
              isRefreshing = false; // I place this reset to remove the lag between different reports updating
            } finally {
              isRefreshing = false; // This reset is essentially a duplicate but kept for the case that the callback errors. This way a successful callback will display data even if a prior errored.
            }
          } else {
            console.log(
              'Skipped refresh as the previous one is still running.',
            );
          }
        });
      return refreshSubscription;
    }
    return null;
  }
}
